// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","408":"song"}[chunkId] + "." + {"177":"a4d05728","408":"3d9cef48"}[chunkId] + ".js";
};